import ClusterSlice from './cluster.slice';

export const { actions: cluster_actions } = ClusterSlice;

export default ClusterSlice.reducer;
